<template>
  <div class="search-item">
    <!-- WEBSITE -->
    <search-item-web
      :item="item"
      v-if="collection === 'wwf-au-web'"
    ></search-item-web>

    <!-- FAQ -->
    <search-item-faq
      :item="item"
      v-else-if="collection === 'wwf-au-faq'"
    ></search-item-faq>

    <!-- YOUTUBE -->
    <search-item-youtube
      :item="item"
      v-else-if="collection === 'wwf-au-youtube'"
    ></search-item-youtube>

    <!-- INSTAGRAM -->
    <search-item-instagram
      :item="item"
      v-else-if="collection === 'wwf-au-instagram'"
    ></search-item-instagram>
  </div>
</template>

<script>
import SearchItemWeb from "./searchItemWeb";
import SearchItemFaq from "./searchItemFaq";
import SearchItemYoutube from "./searchItemYoutube";
import SearchItemTwitter from "./searchItemTwitter";
import SearchItemInstagram from "./searchItemInstagram";

export default {
  name: "SearchItem",
  components: {
    SearchItemWeb,
    SearchItemFaq,
    SearchItemYoutube,
    SearchItemTwitter,
    SearchItemInstagram,
  },
  computed: {
    collection() {
      return this.item.collection;
    },
  },
  props: {
    item: {
      type: Object,
    },
  },
};
</script>

<style scoped>
/* Basic style for all types of results */

.search-item >>> .search-item-container {
  display: flex;
  flex-direction: column;
}

.search-item >>> .search-item-header {
  padding: 12px 20px;
  border-bottom: 1px solid var(--wwfTransparentBlack015);
}

.search-item >>> .search-item-title {
  color: var(--wwfOrange);
}

.search-item >>> .search-item-title h4 {
  margin-bottom: 8px;
  font-size: 22px;
  line-height: 31px;
  word-break: break-word;
}

.search-item >>> .search-item-link a {
  color: var(--wwfGrey52);
  font-style: italic;
  font-size: 16px;
  line-height: 26px;
  word-break: break-all;
}

.search-item >>> .search-item-content {
  padding: 12px 20px;
  word-break: break-all;
}

.search-item >>> .search-item-content img,
.search-item >>> .search-item-content .search-item-image-wrapper {
  display: inline;
  float: right;
  max-height: 130px;
  max-width: 200px;
  margin-left: 1rem;
}

.search-item >>> .search-item-content .search-item-image-wrapper img {
  margin-left: 0;
}

.search-item >>> .search-item-date {
  font-size: 14px;
  color: var(--wwfGrey52);
}
</style>

<style scoped>
.search-item {
  border: 1px solid var(--wwfTransparentBlack015);
}
</style>


// WEBPACK FOOTER //
// searchItem.vue?af70929e